.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
}

.scope {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

.uncalibrated {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.link {
  padding: 0;
  border: 0;
  background: none;
  color: var(--tuna-palette-primary-main);
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.heading {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: 600;
}

.sectionNote {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
}

.row:hover {
  background: var(--tuna-palette-action-hover);
}

/* Selection shows by the filled radio, the border weight and the background, never by colour alone (Joni §2) */
.checked {
  border: 2px solid var(--tuna-palette-primary-main);
  background: var(--tuna-palette-action-selected);
}

.choice {
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(--tuna-spacing-2);
  min-width: 0;
  cursor: pointer;
}

.radio {
  flex: none;
}

.text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  min-width: 0;
}

.label {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-2);
  font-size: var(--tuna-typography-body1-fontSize);
}

.suggested,
.level,
.tag {
  padding: 0 var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-borderRadius);
  font-size: var(--tuna-typography-caption-fontSize);
}

.suggested {
  border: 1px solid var(--tuna-palette-primary-main);
}

.level {
  font-weight: 600;
}

.tag {
  border: 1px solid var(--tuna-border-default);
}

.subLabel {
  flex-basis: 100%;
}

.details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

.thumbnail {
  flex: none;
  width: 6rem;
}

/* A thumbnail is a glance at the contour, not the block's roll */
.thumbnail svg {
  height: 3rem;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--tuna-spacing-2);
}

@media (max-width: 599.95px) {
  .thumbnail {
    width: 4rem;
  }
}
